(function (window, $, Argument, app) {
    var Alert = app.Alert;
    
    function Validation() {
        var _this = this;
        
        var setFormValidityState = function ($form) {
            if ($form.find('.has-error').length === 0) {
                Alert.hide($form.find('.alert'));
            }
        };
        
        var setFieldValidityState = function (field) {
            var $field = $(field);
            var validity = field.validity;
            
            if (validity.valid) {
                $field.parents('.form-group').removeClass('has-error');
            } else {
                $field.parents('.form-group').addClass('has-error');
            }
        };
        
        this.getValidationMessage = function (input) {
            var validity = input.validity;
            
            if (! validity || validity.valid) {
                return '';
            }
            
            if (validity.valueMissing) {
                return $(input).data('reqmsg');
            }
            
            if (validity.patternMismatch || validity.typeMismatch) {
                return $(input).data('invmsg');
            }
            
            return input.validationMessage;
        };
        
        this.error = function (key, errors) {
            var msg = errors[key];
            var $field = $('#frm_field_' + key + '_container');
            var $form = $field.parents('form');
            var id = $form.attr('id').replace('form_', '');
            var tpl = $('#tpl-form-' + id + '-error-message').html();
            var template = app.Template.compile(tpl);
            
            $field.addClass('has-error');
            $field.find('.help-block-error').remove();
            $(template({error: msg})).appendTo($field);
        };
        
        this.bind = function () {
            window.frmThemeOverride_frmPlaceError = this.error;
            
            $('input').on('invalid', function () {
                var $this = $(this);
                var msg;
                
                setFieldValidityState(this);
                
                if ((msg = _this.getValidationMessage(this))) {
                    this.setCustomValidity(msg);
                }
            }).on('input', function () {
                var $this = $(this);
                
                this.setCustomValidity('');
                
                // Only change state to valid on input. Otherwise the field will flash between valid and invalid while a user is typing.
                if (this.validity.valid) {
                    setFieldValidityState(this);
                    setFormValidityState($this.parents('form'));
                }
            }).on('blur', function () {
                var $this = $(this);
                var msg = _this.getValidationMessage(this);
                
                this.setCustomValidity(msg);
                setFieldValidityState(this);
                setFormValidityState($this.parents('form'));
            });
        };
    }
    
    app.registerModule('Validation', new Validation());
})(window, jQuery, Argument, app);

function frmThemeOverride_frmAfterSubmit(formReturned, pageOrder, content, form)
{
    console.log(formReturned);
    console.log(pageOrder);
    console.log(content);
    console.log(form);
}
